go-tab {
  display: none;

  &.active {
    display: block;
  }

  &:focus-visible {
    outline-offset: 0.5rem;
  }
}
